import { Icon, IconProps } from "../Icon";

const WarningFilled = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.8803 27.52L16.8803 2.52002C16.7057 2.1966 16.3678 1.995 16.0003 1.995C15.6328 1.995 15.2949 2.1966 15.1203 2.52002L2.1203 27.52C1.94167 27.8294 1.94167 28.2106 2.1203 28.52C2.30648 28.8261 2.64217 29.0092 3.0003 29H29.0003C29.3534 29 29.6802 28.8137 29.8603 28.51C30.0413 28.2067 30.049 27.8304 29.8803 27.52ZM14.88 10H17.13V20H14.88V10ZM16.0001 26C15.1717 26 14.5001 25.3285 14.5001 24.5C14.5001 23.6716 15.1717 23 16.0001 23C16.8286 23 17.5001 23.6716 17.5001 24.5C17.5001 25.3285 16.8286 26 16.0001 26Z"
      fill="currentColor"
    />
  </Icon>
);

export default WarningFilled;
